import { render } from "./EmailSettingsDialog.vue?vue&type=template&id=c9b9eca0&scoped=true"
import script from "./EmailSettingsDialog.vue?vue&type=script&lang=js"
export * from "./EmailSettingsDialog.vue?vue&type=script&lang=js"

import "./EmailSettingsDialog.vue?vue&type=style&index=0&id=c9b9eca0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b9eca0"]])

export default __exports__